import { useEffect, useState } from 'react';

import { TCommentType } from '@entities/comment/model/types';
import { getCommentTypeByActiveTab } from '@widgets/Comments/lib/polling';

export const useCommentTypeFromActiveTab = (): TCommentType => {
    const [commentType, setCommentType] = useState<TCommentType>(getCommentTypeByActiveTab);

    useEffect(() => {
        const updateCommentType = () => {
            setCommentType((previousType) => {
                const nextType = getCommentTypeByActiveTab();

                return previousType === nextType ? previousType : nextType;
            });
        };

        updateCommentType();

        const observer = new MutationObserver((mutations) => {
            const hasRelevantChange = mutations.some((mutation) => {
                if (mutation.type === 'attributes') {
                    const targetId = (mutation.target as HTMLElement).id;

                    return (
                        mutation.attributeName === 'aria-selected' &&
                        (targetId === 'nav-excess-tab' || targetId === 'nav-extra-works-tab')
                    );
                }

                return mutation.type === 'childList';
            });

            if (hasRelevantChange) {
                updateCommentType();
            }
        });

        observer.observe(document.body, {
            attributes: true,
            attributeFilter: ['aria-selected'],
            childList: true,
            subtree: true,
        });

        return () => {
            observer.disconnect();
        };
    }, []);

    return commentType;
};
